import React from 'react';
import BuildingInfo from './BuildingInfo';

const Buildings = () => {
    return <BuildingInfo type='Building'/>;
};

export default Buildings;
